import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AdditionalToppingsPageRoutingModule } from './additional-toppings-routing.module';

import { AdditionalToppingsPage } from './additional-toppings.page';
import { FooterPageModule } from '../footer/footer.module';
import { FooterPage } from '../footer/footer.page';
import { PipesModule } from 'src/app/shared/pipe/pipe.module';
import { TranslateModule } from '@ngx-translate/core';

import { RowSelectDirective } from 'src/app/shared/directives/row-select.directive';
@NgModule({
  imports: [
    RowSelectDirective,
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    AdditionalToppingsPageRoutingModule,
    FooterPageModule,
    PipesModule
  ],
  declarations: [AdditionalToppingsPage]
})
export class AdditionalToppingsPageModule {}
